import { Warning } from "../common";
import { client } from "../../client";

export const getAccountWarnings = (queryKey: string, accountNumber: string) => {
  return client
    .get<{ results: Warning[] }>(`accounts/${accountNumber}/warnings`)
    .then((response) => response?.data?.results);
};
